import { t } from 'ttag';
import { useState } from 'react';

import LinkFilter, { LinkFilterProps } from '@ui/LinkFilter/LinkFilter';
import FeedFilterTitle from '@components/FeedFilterTitle';

export type FeedCatalogFilterItems = LinkFilterProps['items'];

export const FeedCatalogFilter: React.FC<LinkFilterProps> = ({
  className,
  ...props
}) => {
  const [isHide, setHide] = useState(false);

  return (
    (
      <div className={className}>
        <FeedFilterTitle
          title={t`За категоріями`}
          hide={isHide}
          onClick={() => setHide(!isHide)}
        />
        {!isHide && (
        <LinkFilter
          items={props.items}
          filterParam={props.filterParam}
          filterValueKey={props.filterValueKey}
          initialTreeLevel={props.initialTreeLevel}
          onClick={props.onClick}
        />
        )}
      </div>
    )
  );
};
